// extracted by mini-css-extract-plugin
export default {"upload":"ImgUpload_upload__0MJTe","fileInput":"ImgUpload_fileInput__a3UjP","imgUpload":"ImgUpload_imgUpload__v5pMN","dragActive":"ImgUpload_dragActive__wz80z"};